import { PickKeyOfObject, PickKeyOfString, PickObjectRecursive } from "@/common/declare";
import { observable } from "vue/types/umd";

const properNoun = {

}

const dlc = {
    ACCOUNTING: "会计",
    ACTION: "操作",
    Add: "添加",
    AddAgent: "新增代理商",
    AddArticle: "文章资讯",
    AddBanner: "添加横幅",
    AdditionalContact: "额外联系方式",
    ADDITIONALCONTACT: "额外联系方式",
    ADDITIONALDESCRIPTION: "额外描述",
    address: "地址",
    administrators: "管理员",
    ADULT: "成人",
    Agencyrate: "代理费率",
    AgentInformation: "代理信息",
    AIRCRAFT: "飞机",
    AIRLINES: "航空公司",
    AIRPORTTAX: "机场税",
    all: "全部",
    ALLOW_BAG_SEAT: "行李/座位",
    amount: "金额",
    Amount: "金额",
    ANCILARY: "辅助服务",
    ANCILLARIES: "辅助服务",
    APPROVEDBY: "批准者",
    AreYouSure: "你确定吗？",
    Areyousureseat: "你确定要预订座位吗？",
    ARRIVAL: "到达",
    AVAILABILITY: "可用性",
    Back: "返回",
    balance: "余额",
    Balance: "余额",
    banner: "横幅",
    BasicFare: "基本票价",
    BIRTHDATE: "出生日期",
    BOOK: "预订",
    BOOKCODE: "预订代码",
    BOOKDATE: "预订日期",
    BOOKEDBY: "预订人",
    BOOKINFO: "预订信息",
    CABIN: "舱位",
    CALLER: "呼叫者",
    cancel: "取消",
    CancelBook: "取消预订",
    CANCELBOOKING: "取消预订",
    CancelledBasicFare: "取消的基本票价",
    CancelledSurchargeFee: "取消的附加费",
    CancelledTerminalFee: "取消的终端费",
    cancelorder: "已取消",
    CheckPrice: "检查价格",
    checkURLformat: "充值记录",
    CHILD: "儿童",
    CLASS: "舱位",
    close: "启用",
    Commissionrebate: "佣金回扣",
    Commissionsharing: "其他退款",
    Companydetails: "公司详情",
    confirm: "确认",
    Confirmrefund: "确认退款",
    CONTACT: "联系方式",
    ContactInfo: "联系信息",
    Contactphonenumber: "联系电话",
    Uploadimages: "上传",
    corporateName: "公司名称",
    CREATEBY: "创建者",
    CreateNewBooking: "创建新预订",
    Createrefundform: "创建退款表",
    Creationtime: "创建时间",
    Currency: "货币",
    DATE: "日期",
    Deactivate: "停用",
    Deductionamount: "金额扣除",
    delete: "删除",
    Deleteorder: "删除订单",
    DEP_ARV: "出发/到达",
    Departure: "出发",
    DEPARTURE: "出发",
    DEPARTUREDATE: "出发日期",
    DepartureRouteInfo: "出发路线信息",
    Description: "描述",
    DESCRIPTION: "描述",
    DESTINATION: "目的地",
    DESTNATION: "目的地",
    detail: "详情",
    determine: "确定",
    Disablearticles: "启用",
    Disabled: "禁用",
    DURATION: "时长",
    edit: "编辑",
    email: "邮箱",
    Email: "邮箱",
    Enable: "启用",
    Enablearticles: "禁用",
    EndofTransaction: "交易结束",
    ETicket: "电子票",
    expenditure: "支出",
    FARE: "票价",
    fast: "快速",
    FEES: "费用",
    file: "文件",
    FIRSTNAME: "名",
    FLIGHT: "航班",
    FLIGHTDATE: "航班日期",
    FLIGHTNUMBER: "航班号",
    global: {
        input_add: "添加",
        input_cancel: "取消",
        input_confirm: "确认",
        input_copy: "复制",
        input_disable: "禁用",
        input_edit: "编辑",
        input_enable: "启用",
        input_export: "导出",
        input_filter: "筛选",
        input_search: "搜索",
        input_sync: "刷新",
        label_nav_create: "创建",
        label_nav_edit: "编辑",
        label_no: "否",
        label_warn: "提示",
        label_yes: "是",
        lang_cn: "中文",
        lang_eng: "英文",
        msg_copy_success: "复制成功",
        msg_post_success: "发布成功",
        ph_all: "全部",
        ph_end: "结束日期",
        ph_range: "至",
        ph_start: "开始日期",
        require: "请输入",
        require_phoneNumber: "请输入正确格式的电话号码",
		fn_localPrice: '{localPrice,0}',
		fn_tYMD: '{timeYMD,0,1,2}',
		fn_tHM: '{timeHM,0,1}',
		fn_tDate: '{formatDate,0}',
    },
    GROUPNAME: "团队名称",
    HandmadePlus: "佣金共享",
    home: {
        input_account_hint: "库存SKU/总SKU",
        input_login: "登录",
        input_password_hint: "库存SKU/总SKU",
        input_remember: "记住密码",
        link_forget: "忘记密码？",
        link_regist_1: "没有账号？",
        link_regist_2: "注册",
        require_account: "请输入账号",
        require_password: "请输入密码",
        welcome_1: "欢迎使用Fanslink CDMS",
        welcome_2: ""
    },
    hotspot: "热点",
    income: "收入",
    INFANT: "婴儿",
    INPUTBY: "输入者",
    INPUTDATE: "输入日期",
    INSURANCE: "燃油附加费",
    issuancefailed: "出票失败",
    issuedsuccessfully: "成功出票",
    Keberangkatan: "出发",
    LASTNAME: "姓",
    Loginaccount: "登录账号",
    macroMutexSelector: "macromutex选择",
    Manualdeduction: "更新代理",
    Mobile: "手机号码",
    MOBILE: "电话号码",
    MODIFICATION: "改签",
    ModifyRefundLimit: "修改退款限额",
    MyBookings: "我的预订",
    name: "名称",
    Name: "姓名",
    nationality: "国籍",
    NATIONALITY: "国籍",
    NewBooking: "新预订",
    NEWREFUNDLIMIT: "新的退款限额",
    No: "否",
    NO: "序号",
    normal: "正常",
    notIncomplete: "检查URL格式",
    NUMERICCODE: "数字代码",
    objective: "目的",
    OddNumbers: "订单编号",
    OFFICE: "办公室",
    open: "关闭",
    operation: "操作",
    Ordercompleted: "订单完成",
    Orderrefund: "支付订单",
    ORIGIN: "出发地",
    ORNUMBER: "OR号码",
    OTHERFEE: "其他费用",
    Otherrefunds: "订单退款",
    OUTSTANDING: "金额",
    pagination: {
        label_total: "每页总计(0)"
    },
    PASSENGER: "乘客",
    PassengerInfo: "乘客信息",
    PASSENGERNAME: "乘客姓名",
    PASSENGERS: "乘客",
    PASSPORT: "护照",
    PASSPORTEXPDATE: "护照到期日期",
    PASSPORTEXPIRYDATE: "护照到期日期",
    PASSPORTNUMBER: "护照号码",
    password: "密码",
    PAX: "乘客",
    PaxInfo: "乘客信息",
    PAXTYPE: "乘客类型",
    Payment: "支付",
    PAYMENT: "支付",
    PaymentHistory: "支付历史",
    PaymentOrder: "手动扣款",
    Pendingrefund: "待退款",
    Pendingreview: "待审核",
    phone: "电话号码",
    picture: "图片",
    Pleaseamount: "退款金额",
    PleaseConfirm: "确认",
    Pleaseenter: "输入",
    pleasefeeslist: "确认费用清单",
    pleasereason: "确认原因",
    Pleaseupload: "提示",
    PREPAIDBAGGAGE: "预付行李",
    PreviousBalance: "之前的余额",
    PRINTBOOKING: "下载预订",
    Printltinerary: "打印所有行程",
    PRINTPNR: "打印PNR",
    PrintSMTicket: "打印SM票",
    PRMOMCODE: "优惠码",
    prompt: "提示",
    PULANGPERGI: "往返",
    query: "查询",
    reason: "原因",
    REASON: "原因",
    ReBookFee: "重新预订费",
    RebookInfo: "重新预订信息",
    Recharge: "手动添加",
    Rechargedetails: "充值详情",
    Rechargerecords: "充值记录",
    Refund: "退款",
    REFUND: "退款",
    RefundableAmount: "可退款金额",
    REFUNDABLES: "可退款",
    refundamount: "退款金额",
    Refundcompleted: "退款完成",
    Refundfailed: "退款失败",
    RefundFee: "退款费",
    RefundLimit: "退款限额",
    Refusalrefund: "不允许退款",
    refuse: "拒绝",
    region: "地区",
    Remarks: "备注",
    ReprintReceipt: "重新打印收据",
    RESERVESEAT: "预订座位",
    Restrictsales: "限制销售",
    Returndate: "返回日期",
    role: "角色",
    ROUTE: "路线",
    RouteInfo: "路线信息",
    SATUARAH: "单程",
    SEAT: "座位",
    Seatfailed: "座位预订失败",
    SeatReserved: "已预订座位",
    seatsuccessful: "座位预订成功",
    Selectendtime: "结束时间",
    Selectstarttime: "开始时间",
    SERVICEDAY: "服务天",
    ShowRemarksInfo: "显示备注信息",
    sort: "排序",
    state: "状态",
    STATUS: "状态",
    SURCHARGE: "附加费",
    SurchargeFee: "附加费",
    surplus: "充值",
    TCP: "TCP（完整团队）",
    TerminalFee: "终端费",
    TERMINALFEE: "终端费",
    TICKETING: "订票",
    ticketNo: "票号",
    TICKETNUMBER: "票号",
    time: "时间",
    TIMELIMIT: "时间限制",
    title: "标题",
    TITLE: "称谓",
    TKTNUMBER: "票号",
    tocontinue: "确定",
    TopUp: "充值",
    TOTAL: "总计",
    Totalcost: "总成本",
    TotalPreviousPayment: "之前的总支付",
    TOTALPRICE: "总价",
    TRAMSIT: "中转",
    TRANSACTIONDATE: "交易日期",
    TRANSIT: "中转",
    Turnoffhotspot: "关闭热点",
    Turnonhotspot: "关闭热点",
    type: "类型",
    uac: {
        enum_invalid: "无效",
        enum_valid: "有效",
        input_cancle: "取消",
        input_confirm: "确认",
        input_create: "添加部门",
        input_del: "删除",
        label_add: "添加",
        label_add_part: "添加部门",
        label_delete_depart: "删除部门",
        label_delete_role: "删除角色",
        label_delete_user: "删除用户",
        label_department: "所属部门",
        label_edit: "编辑",
        label_edit_part: "编辑部门",
        label_email: "员工邮箱",
        label_employeeId: "员工编号",
        label_login: "登录",
        label_menu: "菜单",
        label_mobile: "员工电话号码",
        label_name: "员工姓名",
        label_partname: "部门名称",
        label_password: "密码",
        label_remark: "备注",
        label_repeat_password: "重复密码",
        label_role: "用户角色",
        label_roleName: "角色名称",
        label_warn: "警告",
        ph_depart: "部门",
        ph_role: "角色",
        ph_userName: "用户名",
        require_doublepassword: "重新输入密码",
        require_employeename: "输入员工姓名",
        require_employeenumber: "输入员工编号",
        require_nomatch_password: "密码不匹配",
        require_password: "输入密码",
        require_select_role: "输入用户角色",
        require_username: "输入用户名",
        th_authType: "角色类型",
        th_createTime: "创建时间",
        th_depart: "部门",
        th_email: "邮箱",
        th_mobile: "手机号码",
        th_nums: "用户总数",
        th_oparate: "操作",
        th_partname: "部门名称",
        th_remark: "备注",
        th_roleName: "角色名称",
        th_sharp: "",
        th_status: "状态",
        th_userName: "用户名"
    },
    Unavailable: "不可用",
    UpdateAgent: "修改代理",
    UpdateArticle: "更新文章",
    UpdateBanner: "更新横幅",
    content: "内容",
    user: "用户",
    Userapplication: "用户申请",
    USERID: "用户ID",
    VALID: "有效",
    VALIDDATE: "有效日期",
    VALIDTY: "有效期",
    VAT: "增值税",
    VIEWPNR: "查看PNR",
    VIEWSCHEDULE: "查看时间表",
    warehouse: {
        channel: {
            ph_search_channelwhs: "请输入渠道仓库的名称",
            th_channel: "销售渠道",
            th_checkin: "待入库",
            th_freezed: "冻结库存",
            th_mark: "备注",
            th_name: "渠道位置",
            th_number: "",
            th_realwhs: "所属实体仓库",
            th_skuRatio: "库存SKU/总SKU",
            th_sold: "历史销售量"
        },
        enum_disable: "禁用",
        enum_normal: "正常",
        input_cancel: "取消",
        input_create: "创建",
        label_cancelTime: "取消",
        label_mark: "备注",
        ph_datePicker_end: "结束日期",
        ph_datePicker_range: "至",
        ph_datePicker_start: "开始日期",
        real: {
            ph_search_realwhs: "请输入实体仓库的名称",
            th_address: "仓库地址",
            th_channelRef: "渠道位置",
            th_checkin: "待入库",
            th_contact: "仓库联系人",
            th_freezed: "冻结库存",
            th_name: "实体仓库",
            th_number: "",
            th_skuRatio: "库存SKU/总SKU",
            th_sold: "历史销售量"
        },
        td_del: "删除",
        td_edit: "编辑",
        th_oper: "操作",
        th_state: "状态",
        warn_noSel: "请先选择一项"
    },
    Yes: "是",
	Agentcode: "代理商编码",
	Agentlist: "代理商列表",
	Reductions:"转账",
	Transferin:"转入",
	Transferout:"转出",
	operate:"操作",
	Resendticket: "重新发送电子机票",
	travelTax: "旅游费",
	webFee: "订单服务费",
	Abandoned:"废票",
	Auditing:"审核",
	flightawaiting: "删除航段成功，待审核",
	flightFailed: "删除航段失败",
	pnrawaiting: "删除PNR成功，待审核",
	pnrdeletion: "PNR删除失败",
	Invalidticketfailed: "废票失败",
	Pendingpayment: "待支付",
	Flowtype: "流水类型",
	Businesstype: "业务类型",
	Uploadfiles: "上传文件",
	CancelTime: "取消时间",
	agent: "代理商",
	subagent: "子代理",
	RETURN:'返回',
	ADDCITY:'新增航线',
	MULTICITY:"多城市",
	ReturningRouteInfo:"返回路线信息",
	PriceInfo:"价格信息",
	NEXT:"下一步",
	TYPE:"类型",
	SPECIALASSISTANCEREQUIRED:"特殊援助类型",
	areaCode:"国家代码",
	SSRS:'SSRS',
	PRICE:"价格",
	Pleaseselectrefund:"请选择退票航段",
	Pleaseprovidecomplete:"请填写完整",
	Orderexceedslimit:'订单超出限额',
	NonRefundable:'不可退款',
	Expiredthevalidityperiod:'有效期已过',
	seatNum:'座位数量',
	Pleaseselect:'请选择',
	Pleasereschedulingdate:'请选择改签日期',
	Pleaserescheduleflightsegment:'请选择改签航段',
	Cannotbechanged:'不可改签',
	Areyousuretodelete:'确定删除?',
	cannotrefunded:'此航班不可退款',
	operator:'操作人',
	Pleaseenteryouremailaddress:'请输入邮箱',
	refreport:'退改报表',
	salreport:'销售报表',
	uplreport:'承运报表',
	Actualtakeoffstarttime:'实际起飞开始时间',
	Actualtakeoffendtime:'实际起飞结束时间',
	Doistarttime:'Doi开始时间',
	Doiendtime:'Doi结束时间',
	Plannedarrivalendtime:'计划到达结束时间',
	Pleaseselectstartandenddates:'请选择开始和结束日期',
	PleaseselectDoitakeofftime:'请选择Doi开始结束时间或起飞开始结束时间',
	noshowreport:'弃乘报表',
	UndefinedReport:'特殊报表',
	imageuploadTypeTip:'只能上传图片',
	imageuploadSizeTip:'图片大小不能超过 2MB',
    // 本地化函数
    _f: {
        localPrice: (price: number) => {
            if (typeof price !== 'number') {
                return '';
            }

            let minus = price < 0;
            let price100x = Math.abs(Math.floor(price * 100 + 0.5));

            const floatPart = price100x % 100
            price100x = Math.floor(price100x / 100);

            const intPart: string[] = [];

            while (price100x > 999) {
                intPart.unshift((price100x % 1000).toString().padStart(3, '0'));
                price100x = Math.floor(price100x / 1000);
            };

            intPart.unshift(price100x.toString());
            return `${minus ? '-' : ''}${intPart.join(',')}.${floatPart.toString().padStart(2, '0')}`;
        },
        timeYMD: (y: number, mn: number, d: number) => {
            const formatNumber = dlc._f.formatNumber;
            return `${y}-${formatNumber(mn)}-${formatNumber(d)}`;
        },
        timeHM: (h: number, m: number) => {
            const formatNumber = dlc._f.formatNumber;
            return `${formatNumber(h)}:${formatNumber(m)}`;
        },
        formatDate: (date: Date) => {
            const formatNumber = dlc._f.formatNumber;
            const y = date.getFullYear();
            const mn = formatNumber(date.getMonth() + 1);
            const d = formatNumber(date.getDate());
            const h = formatNumber(date.getHours());
            const m = formatNumber(date.getMinutes());
            const s = formatNumber(date.getSeconds());

            return `${y}-${mn}-${d} ${h}:${m}:${s}`;
        },
        formatNumber: (n: number) => {
            return n.toString().padStart(2, '0')
        }
    }
}

type LangPack = typeof dlc;

export type I18nBase = Exclude<PickKeyOfObject<LangPack>, 'global' | '_f'>
export type I18nExtend<T extends keyof LangPack> = PickKeyOfObject<LangPack[T]>

export type LangNsp = PickObjectRecursive<typeof dlc>

export default { dlc };